import react, {Fragment, useLayoutEffect, useRef} from "react";
import styled from "styled-components";
import {useNavigate} from "react-router";
import Button from "components/ui/Button";
import iconError from "assets/icons/icon_error_disappoint.svg";

export const Error = ({mode, message, onRefresh}) => {
	const self = useRef();
	const navigate = useNavigate();
	const eventHandler = {
		refresh : (event) => {
			if(onRefresh) onRefresh();
			else window.location.reload();
		},
		back : () => {
			navigate(-1);
		}
	};

	useLayoutEffect(() => {
		const height = (self.current) ? self.current.offsetHeight : 0;
		if(height < 250) {
			self.current.classList.add("small");
		}
	}, []);

	return (
		<Wrapper ref={self} className={mode}>
			<div className="box">
				<div className="top" />
				<div className="middle">
					<img src={iconError} />
					<h4>이용에 불편을 드려 죄송합니다.</h4>
					<p>
						{
							(message) ? message :
							<Fragment>
								해당 페이지의 접속이 지연되고 있어요.<br/>
								잠시 후 다시 시도해주세요.
							</Fragment>
						}
						<span><a onClick={eventHandler.refresh}>새로고침하기</a></span>
					</p>
				</div>
				<div className="bottom">
					<Button color="blue" outline onClick={eventHandler.refresh}>새로고침</Button>
					<Button color="blue" onClick={eventHandler.back}>뒤로가기</Button>
				</div>
			</div>
		</Wrapper>
	);
};

const Wrapper = styled.div`
&									{position:absolute; left:0; top:0; right:0; bottom:0;
									 display:flex; align-items:center; justify-content:center;
									 padding:24px; background-color:white; text-align:center}
&.page								{bottom:60px}
&.child								{top:50px}
&.section							{background-color:transparent !important}

&.small								{position:relative; padding:0}

.box								{padding-bottom:75px}
.box .middle						{padding:24px 0}
.box .middle img					{margin:0 auto; width:60px}
.box .middle h4						{margin:16px 0 8px 0; font-size:var(--18px); font-weight:600}
.box .middle p						{text-align:center; color:#727b8e}
.box .middle p span					{display:none; margin-top:2px; font-size:var(--14px); font-weight:normal; color:var(--darkGray)}

.box .bottom						{display:flex; justify-content:center}
.box .bottom button					{min-width:120px; border-color:#d4d9e3}
.box .bottom button + button		{margin:0 0 0 16px}

&.section {
	.box							{padding-bottom:50px}
	.box .bottom button + button	{display:none}
	}

&.section.small {
	&								{position:absolute}
	.box .middle p span				{display:block}
	.box .middle p span a			{text-decoration:underline; color:var(--blue)}		
	.box .bottom					{display:none}
	}
	

	
&.small {
	.box							{padding:0}
	.box .top						{display:none}	
	.box .middle					{display:flex; margin:0; padding:0; align-items:center; justify-content:center}
	.box .middle img				{width:40px; height:40px}
	.box .middle h4					{display:none}
	.box .middle p					{margin-left:16px; line-height:1.3; text-align:left; font-size:14px; text-overflow:ellipsis; white-space:nowrap; overflow:hidden}
	.box .middle p span				{display:block}
	.box .bottom 					{display:none}
	}
}
`;

export default Error;